import { Unit } from "./Unit";
import { TeamCost } from "./TeamCost";
import { getRandomInt } from "./utils";
import { UnitCost, UnitCostRange } from "./UnitCost";


export interface TeamOptions {
    disallowInvalidCostCombination: boolean;
    disallowLowCostPair: boolean;
}


export namespace Team {
    export function random(options: TeamOptions): [Unit, Unit] {
        const units = Unit.getAll();

        for (let i = 0; i < 10000; i++) {
            const p1 = units[getRandomInt(units.length)];
            const p2 = units[getRandomInt(units.length)];

            if (options.disallowInvalidCostCombination) {
                if (!isValidCostCombination(p1, p2)) {
                    continue;
                }
            }

            if (options.disallowLowCostPair) {
                if (UnitCost.toUnitCostRange(p1.cost) === UnitCostRange.low && UnitCost.toUnitCostRange(p2.cost) === UnitCostRange.low) {
                    continue;
                }
            }

            return [p1, p2];
        }

        throw new Error(``);
    }


    export function isValidCostCombination(a: Unit, b: Unit): boolean {
        const maxTeamCost = TeamCost.getMaxTeamCost(a, b);

        return 900 <= maxTeamCost;
    }
}
